<!-- Updated Sidebar Close Component for Mobile Bottom Navigation -->
<script setup lang="ts">
    import { menuDefault, menuProfile } from '@/data/sidebar';
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    const route = useRoute();

    const menu = computed(() => {
        return menuProfile.some(menu => menu.group === route.meta.group)
            ? menuProfile
            : menuDefault;
    });

    const active = (item: { group: string }) => item.group === route.meta.group;

    const isMobile = computed(() => window.innerWidth < 768);
</script>

<template>
    <div
        v-if="isMobile"
        class="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-2px_4px_rgba(0,0,0,0.1)] z-40 flex justify-around py-3"
    >
        <template v-for="item in menu" :key="item.path">
            <button
                :class="[
                    active(item) ? 'text-brand-500' : 'text-default-800',
                    'flex flex-col items-center justify-center transition-colors duration-200'
                ]"
                @click="$router.push({ path: item.path })"
                :title="item.label"
            >
                <component :is="item.icon" :size="24" :weight="active(item) ? 'fill' : 'regular'" />
            </button>
        </template>
    </div>
</template>
